import store from '../store';
import utils from 'web3-utils';
import requestPromise from 'request-promise';
import moment from 'moment-timezone';
import contract from "truffle-contract"
import BetManagerContract from '../contracts/BetManager.json'
import Web3 from 'web3'

/**************************** START SHARED ****************************/


export function generateHashData(betText, participant1Address, participant2Address, arbiterAddress, participant1Username, participant2Username, arbiterUsername, amount1, amount2, arbitrationFee, arbitrationRequestDate, daysBeforeDefaultJudgement, betExpiresDate) {

    let betAmount1Wei = utils.toWei(amount1.toString(), 'ether');
    let betAmount2Wei = utils.toWei(amount2.toString(), 'ether');
    let arbitrationFeeWei = utils.toWei(arbitrationFee.toString(), 'ether');
    let daysBeforeDefaultJudgementStr = daysBeforeDefaultJudgement.toString();
    let arbitrationRequestDateUnix = moment.tz(arbitrationRequestDate, "MM/DD/YYYY", 'America/Los_Angeles').unix().toString();
    let betExpiresDateUnix = moment.tz(betExpiresDate, "MM/DD/YYYY", 'America/Los_Angeles').unix().toString();

    let hashData = {
        bettor1Address: participant1Address,
        bettor2Address: participant2Address,
        arbiterAddress: arbiterAddress,
        bettor1Username: participant1Username,
        bettor2Username: participant2Username,
        arbiterUsername: arbiterUsername,
        betAmount1Wei: betAmount1Wei,
        betAmount2Wei: betAmount2Wei,
        arbitrationFeeWei : arbitrationFeeWei,
        betExpiresDateUnix: betExpiresDateUnix,
        arbitrationRequestDateUnix: arbitrationRequestDateUnix,
        daysToRespondToArbitrationBeforeLosing: daysBeforeDefaultJudgementStr,
        betText: betText
    };

    let hashDataStr = JSON.stringify(hashData);
    let sha3 = utils.sha3(hashDataStr);
    return { data: hashDataStr, sha3: sha3 };
}

export function getSignatureMessage(ethAccount, username, tweetId, blockNum, blockHash) {    
  const message = "My twitter username is @" + username.toLowerCase() + " and my Ethereum address is " + ethAccount.toLowerCase() + ".\n\n\n\n--------------------------\nTwitter verification URL: https://twitter.com/" + username.toLowerCase() + "/status/" + tweetId + "\nLatest Ethereum block #: " + blockNum + "\nLatest Ethereum block hash: " + blockHash;
  return message;
}

/**************************** END SHARED ****************************/

export function checkBetHashesMatch(betId) {

    const { blockchainDataMap, hashDataMap } = store.getState().bet;
    let blockchainData = blockchainDataMap.hasOwnProperty(betId) ? blockchainDataMap[betId] : null;
    let { hashData=null, betHash="" } = hashDataMap.hasOwnProperty(betId) ? hashDataMap[betId] : {};


    if(blockchainData && hashData) {

        let betHashOnBlockchain = blockchainData.betHash;

        let { sha3 } = generateHashData(hashData.betText, 
                            blockchainData.addressParticipant1, 
                            blockchainData.addressParticipant2, 
                            blockchainData.addressArbiter, 
                            hashData.bettor1Username, 
                            hashData.bettor2Username, 
                            hashData.arbiterUsername, 
                            blockchainData.person1BetAmount, 
                            blockchainData.person2BetAmount, 
                            blockchainData.arbitrationFee, 
                            moment.unix(blockchainData.arbitrationRequestAllowedAfterTimestamp, 'America/Los_Angeles').format("MM/DD/YYYY"), 
                            blockchainData.daysToPayArbitrationFeeAfterArbitrationRequest, 
                            moment.unix(blockchainData.betCanceledAfterTimestamp, 'America/Los_Angeles').format("MM/DD/YYYY"));
        
        return (sha3 === betHash) && (sha3 === betHashOnBlockchain);
    }
    
    return false;
}

/*
    hashData
    =====
    "bettor1Address":"0x91d7eaba4dde9799c12bf054b6023f45c72a4a56",
    "bettor2Address":"0x39d8e84ef765360cdc1ca65d30333b92732bf09f",
    "arbiterAddress":"0x0d1d4e623d10f9fba5db95830f7d3839406c6af2",
    "bettor1Username":"ethgeek",
    "bettor2Username":"maimedprisoner",
    "arbiterUsername":"ethbetarbiter",
    "betAmount1Wei":"10000000000000000",
    "betAmount2Wei":"10000000000000000",
    "arbitrationFeeWei":"1000000000000000",
    "betExpiresDateUnix":"1535526000",
    "arbitrationRequestDateUnix":"1533106800",
    "daysToRespondToArbitrationBeforeLosing":"60",
    "betText":"If Germany or Spain wins the world cup in 2018 then @maimedprisoner wins, otherwise @ethgeek wins."}"
    */

export function betStatusFromDatabase(keyUsername, keyProposal) {

    if(!keyUsername || !keyProposal) {
        return null;
    }

    const { proposalDataMap, blockchainDataMap, hashDataMap, authentication } = store.getState().bet;
    let combinedKey = JSON.stringify([keyUsername, keyProposal]);
    let proposalData = proposalDataMap[combinedKey];
    let betId = "";
    let finalize = null;
    let common = (proposalData && proposalData.common) || {};
    if(proposalData && proposalData.hasOwnProperty("finalize") && proposalData.finalize && proposalData.finalize.hasOwnProperty("betId")) {
        betId = proposalData.finalize.betId;
        finalize = proposalData.finalize;
    }

    let blockchainData = blockchainDataMap.hasOwnProperty(betId) ? blockchainDataMap[betId] : null;
    let { hashData=null, betHash="" } = hashDataMap.hasOwnProperty(betId) ? hashDataMap[betId] : {};

    // -----------------------------------------------------
    // Usernames of participants
    let username = authentication.username;
    let participant1 = common.participant1;
    let participant2 = common.participant2;
    let arbiter = common.arbiter;
    if(hashData) {
        //Load from hash data if on blockchain
        participant1 = hashData.bettor1Username;
        participant2 = hashData.bettor2Username;
        arbiter = hashData.arbiter;
    }
    let opponent = (participant1 !== username ? participant1 : participant2);

    // -----------------------------------------------------
    // Level of agreement/finalization
    let final = false;
    let submitted = false;
    const AGREEMENT_NONE = 0;
    const AGREEMENT_INITIAL = 1;
    const AGREEMENT_SUBMITTED = 2;
    const AGREEMENT_FINALIZED = 3;
    let agreementLevel = AGREEMENT_NONE;
    let agreedVersion = "";
    if(common.hasOwnProperty("agreedVersion") && common.agreedVersion !== "") {
        agreedVersion = common.agreedVersion;
        agreementLevel = AGREEMENT_INITIAL;
    }
    if(finalize) {
        if(finalize.submitted) {
            submitted = true;
            agreementLevel = AGREEMENT_SUBMITTED;
        }
        if(finalize.final && betId !== "") {
            final = true;
            agreementLevel = AGREEMENT_FINALIZED;
        }
    }

    // -----------------------------------------------------
    // Resolution status for bet on blockchain
    const RESOLUTION_NONE = 0;
    const RESOLUTION_PERSON1WINS = 1;
    const RESOLUTION_PERSON2WINS = 2;
    const RESOLUTION_TIE = 3;
    let resolution = RESOLUTION_NONE;
    let person1Resolution = RESOLUTION_NONE;
    let person2Resolution = RESOLUTION_NONE;
    let arbiterResolution = RESOLUTION_NONE;
    if(blockchainData) {
        resolution = parseInt(blockchainData.resolution, 10);
        person1Resolution = parseInt(blockchainData.person1Resolution, 10);
        person2Resolution = parseInt(blockchainData.person2Resolution, 10);
        arbiterResolution = parseInt(blockchainData.arbiterResolution, 10);
    }
    const resolutionMessages = [
        "None",
        "@" + participant1 + " wins",
        "@" + participant2 + " wins",
        "It's a tie",
    ];

    // -----------------------------------------------------
    // Whether DB matches blockchain
    let betHashesMatch = checkBetHashesMatch(betId);

    // -----------------------------------------------------
    // Blockchain deposit and resolution details
    let yourDepositNeeded = 0;
    let opponentDepositNeeded = 0;
    let yourBalance = 0;
    let yourBetAmount = 0;
    let yourResolution = 0;
    let opponentBalance = 0;
    let opponentBetAmount = 0;
    let opponentResolution = 0;
    let youWon = false;
    let opponentWon = false;
    let tieWon = false;
    if(username === participant1) {
        if(blockchainData) {
            yourBetAmount = parseFloat(blockchainData.person1BetAmount);
            yourDepositNeeded = Math.max(0, parseFloat(blockchainData.person1BetAmount) - parseFloat(blockchainData.person1Balance));
            opponentDepositNeeded = Math.max(0, parseFloat(blockchainData.person2BetAmount) - parseFloat(blockchainData.person2Balance));
            yourBalance = parseFloat(blockchainData.person1Balance);
        }
        yourResolution = person1Resolution;
        opponentResolution = person2Resolution;
        youWon = (resolution === RESOLUTION_PERSON1WINS);
        opponentWon = (resolution === RESOLUTION_PERSON2WINS);
    }
    else if(username === participant2) {
        if(blockchainData) {
            yourBetAmount = parseFloat(blockchainData.person2BetAmount);
            yourDepositNeeded = Math.max(0, parseFloat(blockchainData.person2BetAmount) - parseFloat(blockchainData.person2Balance));
            opponentDepositNeeded = Math.max(0, parseFloat(blockchainData.person1BetAmount) - parseFloat(blockchainData.person1Balance));
            yourBalance = parseFloat(blockchainData.person2Balance);
        }
        yourResolution = person2Resolution;
        opponentResolution = person1Resolution;
        youWon = (resolution === RESOLUTION_PERSON2WINS);
        opponentWon = (resolution === RESOLUTION_PERSON1WINS);
    }
    tieWon = (resolution === RESOLUTION_TIE);
    let arbitrationFee = 0;
    if(blockchainData) {
        arbitrationFee = parseFloat(blockchainData.arbitrationFee);
    }
    let yourArbitrationFeeBalance = yourBalance > yourBetAmount ? yourBalance - yourBetAmount : 0;
    let opponentArbitrationFeeBalance = opponentBalance > opponentBetAmount ? opponentBalance - opponentBetAmount : 0;

    // -----------------------------------------------------
    // Arbitration
    let person1RequestedArbitration = false;
    let person2RequestedArbitration = false;
    let arbitrationOccurred = false;
    let arbitrationJudgmentAllowedAfterTimestamp = 0;
    let defaultJudgmentOccurred = false;
    if(blockchainData) {
        person1RequestedArbitration = blockchainData.person1RequestedArbitration;
        person2RequestedArbitration = blockchainData.person2RequestedArbitration;
        arbitrationOccurred = blockchainData.arbitrationOccurred;    
        arbitrationJudgmentAllowedAfterTimestamp = blockchainData.arbitrationJudgmentAllowedAfterTimestamp;  
        defaultJudgmentOccurred = blockchainData.defaultJudgmentOccurred;
    }
    let momentArbitrationJudgmentAllowed = moment.unix(arbitrationJudgmentAllowedAfterTimestamp).tz('America/Los_Angeles');
    let remainingDaysBeforeJudgmentAllowed = momentArbitrationJudgmentAllowed.diff(moment().tz('America/Los_Angeles'), 'days');
    let arbitrationRequested = person1RequestedArbitration || person2RequestedArbitration;

    // -----------------------------------------------------
    // Withdraw and finalization
    let onlyWithdrawAllowed = false;
    if(blockchainData) {
        onlyWithdrawAllowed = blockchainData.onlyWithdrawAllowed;
    }
    let submitAttemptedNotFinal = (!final && submitted) || (final && !betHashesMatch);
    let finalAndMatching = final && betHashesMatch;

    // -----------------------------------------------------
    // Bet status message 
    let betStatusMsg = "Proposed";
    if(finalAndMatching) {
        if(onlyWithdrawAllowed) {
            if(resolution === RESOLUTION_NONE) {
                betStatusMsg = "Canceled";
            }
            else {
                betStatusMsg = "Resolved";
            }
        }
        else {
            if(yourDepositNeeded === 0 && opponentDepositNeeded === 0) {
                betStatusMsg = "Active";
            }
            else {
                betStatusMsg = "Unfunded";
            }
        }
    }

    let response = {
        betId, betStatusMsg, resolutionMessages, final, submitted, 
        username, opponent, participant1, participant2, arbiter, 
        agreementLevel, agreedVersion, AGREEMENT_NONE, AGREEMENT_INITIAL, AGREEMENT_SUBMITTED, AGREEMENT_FINALIZED,
        resolution, person1Resolution, person2Resolution, arbiterResolution, opponentResolution, yourResolution, 
        yourDepositNeeded, opponentDepositNeeded, yourBalance, yourBetAmount, opponentBalance, opponentBetAmount, 
        arbitrationFee, yourArbitrationFeeBalance, opponentArbitrationFeeBalance,
        youWon, opponentWon, tieWon, 
        RESOLUTION_NONE, RESOLUTION_PERSON1WINS, RESOLUTION_PERSON2WINS, RESOLUTION_TIE,
        person1RequestedArbitration, person2RequestedArbitration, arbitrationRequested, arbitrationOccurred, 
        arbitrationJudgmentAllowedAfterTimestamp, momentArbitrationJudgmentAllowed, remainingDaysBeforeJudgmentAllowed, 
        defaultJudgmentOccurred, onlyWithdrawAllowed, submitAttemptedNotFinal, finalAndMatching, 
        betHashesMatch, betHash
    };

    console.log("betStatusFromDatabase: " + keyUsername + ", " + keyProposal + ", " + betId);
    console.log(response);

    return response;
}

export function getStatePromise(betId, ethAccount) {

    const { betManagerInstance } = store.getState().bet.web3;

    let statePromiseArr = [];
    statePromiseArr.push(betManagerInstance.betHash.call(betId, {from: ethAccount}));
    statePromiseArr.push(betManagerInstance.bettor.call(betId, 0, {from: ethAccount}));
    statePromiseArr.push(betManagerInstance.bettor.call(betId, 1, {from: ethAccount}));
    statePromiseArr.push(betManagerInstance.arbiter.call(betId, {from: ethAccount}));
    statePromiseArr.push(betManagerInstance.bettorBetAmount.call(betId, 0, {from: ethAccount}));
    statePromiseArr.push(betManagerInstance.bettorBetAmount.call(betId, 1, {from: ethAccount}));
    statePromiseArr.push(betManagerInstance.bettorPaidAmount.call(betId, 0, {from: ethAccount}));
    statePromiseArr.push(betManagerInstance.bettorPaidAmount.call(betId, 1, {from: ethAccount}));
    statePromiseArr.push(betManagerInstance.arbitrationFee.call(betId, {from: ethAccount}));

    statePromiseArr.push(betManagerInstance.daysToPayArbitrationFee.call(betId, {from: ethAccount}));
    statePromiseArr.push(betManagerInstance.arbitrationNextStepAllowedAfterTimestamp.call(betId, {from: ethAccount}));
    statePromiseArr.push(betManagerInstance.betCanceledAfterTimestamp.call(betId, {from: ethAccount}));
    statePromiseArr.push(betManagerInstance.arbitrationNextStepAllowedAfterTimestamp.call(betId, {from: ethAccount}));

    statePromiseArr.push(betManagerInstance.arbitrationOccurred.call(betId, {from: ethAccount}));
    statePromiseArr.push(betManagerInstance.defaultJudgmentOccurred.call(betId, {from: ethAccount}));
    statePromiseArr.push(betManagerInstance.bettorRequestedArbitration.call(betId, 0, {from: ethAccount}));
    statePromiseArr.push(betManagerInstance.bettorRequestedArbitration.call(betId, 1, {from: ethAccount}));
    statePromiseArr.push(betManagerInstance.onlyWithdrawAllowed.call(betId, {from: ethAccount}));

    statePromiseArr.push(betManagerInstance.bettorResolution.call(betId, 0, {from: ethAccount}));
    statePromiseArr.push(betManagerInstance.bettorResolution.call(betId, 1, {from: ethAccount}));
    statePromiseArr.push(betManagerInstance.arbiterResolution.call(betId, {from: ethAccount}));
    statePromiseArr.push(betManagerInstance.resolution.call(betId, {from: ethAccount}));

    return Promise.all(statePromiseArr);
}

export function refreshBetList(betIdList) {
    return function(dispatch) {

        const { betManagerInstance, ethAccount } = store.getState().bet.web3;

        if(!betManagerInstance) { return null; };

        let promiseBetStateArr = [];
        if(betIdList.length > 0) {
            for(let i=betIdList.length-1; i>=0; i--) {
                promiseBetStateArr.push(getStatePromise(betIdList[i], ethAccount));
            }
        }

        return Promise.all(promiseBetStateArr).then(function(betData) {
            
            for(let i=0; i<betData.length; i++) {
            
                let betId = betIdList[i].toString();
                
                let data = {
                    betId: betId,
                    betHash: betData[i][0].toString(),
                    addressParticipant1: betData[i][1].toString(),
                    addressParticipant2: betData[i][2].toString(),
                    addressArbiter: betData[i][3].toString(),
                    person1BetAmount: utils.fromWei(betData[i][4].toString(), "ether"),
                    person2BetAmount: utils.fromWei(betData[i][5].toString(), "ether"),
                    person1Balance: utils.fromWei(betData[i][6].toString(), "ether"),
                    person2Balance: utils.fromWei(betData[i][7].toString(), "ether"),
                    arbitrationFee: utils.fromWei(betData[i][8].toString(), "ether"),

                    daysToPayArbitrationFeeAfterArbitrationRequest: betData[i][9].toString(),
                    arbitrationRequestAllowedAfterTimestamp: betData[i][10].toString(),
                    betCanceledAfterTimestamp: betData[i][11].toString(),
                    arbitrationJudgmentAllowedAfterTimestamp: betData[i][12].toString(),

                    arbitrationOccurred: betData[i][13],
                    defaultJudgmentOccurred: betData[i][14],
                    person1RequestedArbitration: betData[i][15],
                    person2RequestedArbitration: betData[i][16],
                    onlyWithdrawAllowed: betData[i][17],

                    person1Resolution: betData[i][18].toString(),
                    person2Resolution: betData[i][19].toString(),
                    arbiterResolution: betData[i][20].toString(),
                    resolution: betData[i][21].toString()
                };
                
                dispatch({
                    type: 'UPDATE_BLOCKCHAIN_DATA',
                    payload: { betId, data }
                });    
            }

            return null;

        }).catch((error) => {

            console.log("Error with refreshBetList");
            console.log(error);
            return null;
        });
    }
}

export function stringToInteger(str) {
  return parseInt(str, 10) || 0;
}

export function checkMetamask(dispatch) {
    if (typeof window.web3 !== 'undefined') {
        let { selectedAddress = "", networkVersion="" } = window.web3.currentProvider.publicConfigStore.getState();
        if(window.selectedAddressVal !== selectedAddress || window.selectedNetworkVersionVal !== networkVersion) {

            let network = "unknown";
            if(networkVersion === "1" || networkVersion === 1) {
                network = "main";
            }
            else if(networkVersion === "3" || networkVersion === 3) {
                network = "ropsten";
            }
            else if(networkVersion === "42" || networkVersion === 42) {
                network = "kovan";
            }
            else if(networkVersion === "4" || networkVersion === 4) {
                network = "rinkeby";
            }

            if(selectedAddress === "") {
                network = "";
            }

            let web3 = new Web3(window.web3.currentProvider);
            window.selectedAddressVal = selectedAddress;
            window.selectedNetworkVersionVal = networkVersion;
            dispatch(loginFromEthAccount(selectedAddress, network, false));
            dispatch(updateWeb3Contracts(web3, selectedAddress, network));
        }
    }
    else {
        if(window.selectedAddressVal !== "" || window.selectedNetworkVersionVal !== "") {
            window.selectedAddressVal = "";
            window.selectedNetworkVersionVal = "";
            dispatch(loginFromEthAccount("", "", false));
            dispatch(updateWeb3Contracts(null, "", ""));
        }
    }
}

export function checkTxHashes(txHashList) {
    return function(dispatch) {

        const { web3Instance } = store.getState().bet.web3;
        const { authentication } = store.getState().bet;

        for(let i=0; i<txHashList.length; i++) {
            let txHash = txHashList[i].txHash;
            let ctx = txHashList[i].data;

            if(web3Instance && txHash) {
                web3Instance.eth.getTransactionReceipt(txHash).then((receipt) => {

                    if(receipt && receipt.hasOwnProperty("blockNumber") && receipt.blockNumber && receipt.hasOwnProperty("logs") && receipt.logs.length > 0 && receipt.logs[0].hasOwnProperty("data")) {
    
                        var logData = receipt.logs[0].data;
                        let eventBetHash = logData.substring(0, 66);
                        let eventBetId = logData.substring(66);
                        eventBetId = eventBetId.replace(/^0+/, '');
    
                        if(eventBetHash === ctx.betHash) {
                            console.log("BetHash matches! " + eventBetHash + ", " + eventBetId);
                            dispatch(finalizeBet(authentication.uuid, ctx.keyUsername, ctx.keyProposal, ctx.keyVersion, ctx.betHash, txHash, eventBetId, ctx.network));
                        }
                        else {
                            console.log("Error: betHash doesn't match");
                        }
                    }
                });
            }
        }
    }
}

export function checkActiveBet(dispatch) {
    let { monitorBetIds, monitorTxHashes } = store.getState().bet;

    if(monitorBetIds.length > 0) {
        dispatch(refreshBetList(monitorBetIds));
    }

    if(monitorTxHashes.length > 0) {
        dispatch(checkTxHashes(monitorTxHashes));
    }
}

export function initWeb3(payload) {
    return function(dispatch) {
        checkMetamask(dispatch);

        window.setInterval(() => {
            checkMetamask(dispatch);
        }, 200);

        window.setInterval(() => {
            checkActiveBet(dispatch);
        }, 5000);

      }    
}

export function updateWeb3Contracts(web3, addr, network) {
    return function(dispatch) {

        let betManagerContract = contract(BetManagerContract);
        betManagerContract.setProvider(web3.currentProvider);

        let betManagerInstance = null;

        betManagerContract.deployed()
        .then((instance) => {
            betManagerInstance = instance;

            dispatch({type: "UPDATE_WEB3", payload: {
                web3Instance: web3,
                betManagerContract: betManagerContract,
                betManagerInstance: betManagerInstance,
                ethAccount: addr,
                network: network
            }});

        }).catch((err) => {

            console.log("Exception initializing web3")

            dispatch({type: "UPDATE_WEB3", payload: {
                web3Instance: null,
                betManagerContract: null,
                betManagerInstance: null,
                ethAccount: "",
                network: ""
            }});

        });
    }
}


export function createBetFromInput(input, context, authentication) {
  return function(dispatch) {
    if(authentication.hasDatabaseAuth) {
      dispatch(createBetOnBlockchain(authentication, context.keyUsername, context.keyProposal, context.keyVersion, context.twoWayVerified, authentication.ethAccount, input.betText, context.participant1, context.participant2, context.arbiter, input.amount1, input.amount2, input.arbitrationFee, input.arbitrationRequestDate, input.daysBeforeDefaultJudgement, input.betExpiresDate));
    }
    else {
      console.log("No auth");
    }
  }
}


export function createBetOnBlockchain(authentication, keyUsername, keyProposal, keyVersion, twoWayVerified, ethAccount, betText, participant1, participant2, arbiter, amount1, amount2, arbitrationFee, arbitrationRequestDate, daysBeforeDefaultJudgement, betExpiresDate) {
    return function(dispatch) {

        let addressParticipant1 = "";
        let addressParticipant2 = "";
        let addressArbiter = "";
        if(twoWayVerified && twoWayVerified.length === 3) {
            for(let i=0; i<twoWayVerified.length; i++) {
                let twoWayEntry = twoWayVerified[i];

                if(twoWayEntry && twoWayEntry.username === participant1) {
                    addressParticipant1 = twoWayEntry.address;
                }

                if(twoWayEntry && twoWayEntry.username === participant2) {
                    addressParticipant2 = twoWayEntry.address;
                }

                if(twoWayEntry && twoWayEntry.username === arbiter) {
                    addressArbiter = twoWayEntry.address;
                }
            }
        }

        if(addressParticipant1 !== "" && addressParticipant2 !== "" && addressArbiter !== "") {

            let { data, sha3 } = generateHashData(betText, addressParticipant1, addressParticipant2, addressArbiter, participant1, participant2, arbiter, amount1, amount2, arbitrationFee, arbitrationRequestDate, daysBeforeDefaultJudgement, betExpiresDate);
            let dataObj = JSON.parse(data);

            const { betManagerInstance } = store.getState().bet.web3;

            if(betManagerInstance) {

                let bettor0BetAmount = dataObj.betAmount1Wei;
                let bettor1BetAmount = dataObj.betAmount2Wei;
                let arbitrationFee = dataObj.arbitrationFeeWei;
                let arbitrationRequestAllowedAfterTimestamp = dataObj.arbitrationRequestDateUnix;
                let daysToPayArbitrationFeeAfterArbitrationRequest = dataObj.daysToRespondToArbitrationBeforeLosing;
                let betCanceledAfterTimestamp = dataObj.betExpiresDateUnix;

                betManagerInstance.createCombinedData.call(
                    bettor0BetAmount,
                    bettor1BetAmount,
                    arbitrationFee,
                    arbitrationRequestAllowedAfterTimestamp,
                    daysToPayArbitrationFeeAfterArbitrationRequest,
                    betCanceledAfterTimestamp,
                    {from: ethAccount}).then((combinedData) => {

                    return betManagerInstance.createBet.sendTransaction(sha3, [addressParticipant1, addressParticipant2, addressArbiter], combinedData, {from: ethAccount});
                }).then((txHash) => {
                    dispatch(finalizeBet(authentication.uuid, keyUsername, keyProposal, keyVersion, sha3, txHash, "", authentication.network));
                    return null;
                }).catch((err) => {
                    console.log("Error in createBetOnBlockchain");
                    console.log(err);
                    return null;
                });
            }
        }
        return null;
    }
}


export function finalizeBet(uuid, keyUsername, keyProposal, keyVersion, betHash, txHash, betId, network) {
  return function(dispatch) {

    dispatch(changePageContext({pendingFinalize:true}, "VIEW_PROPOSAL"));

    const options = {
      uri: "https://ethbet.network/finalizeBet?uuid=" + uuid + "&username=" + keyUsername + "&key=" + keyProposal + "&version=" + keyVersion + "&txHash=" + txHash + "&betHash=" + betHash + "&betId=" + betId + "&network=" + network
    };
    let t0 = performance.now();
    
    return requestPromise(options).then((response) => {

      let t1 = performance.now();
      console.log("Time for finalizeBet " + (t1 - t0) + " milliseconds.");
    
      let responseObj = JSON.parse(response);
      console.log(responseObj);
      if(responseObj && responseObj.hasOwnProperty('success') && responseObj.hasOwnProperty('finalize') && responseObj.success === true) {
        let context = {};

        context.finalize = {};
        context.final = false;
        context.submitted = false;
        context.betId = "";
        if(responseObj.hasOwnProperty("finalize")) {
            context.finalize = responseObj.finalize;

            if(responseObj.finalize.hasOwnProperty("final")) {
                context.final = responseObj.finalize.final;
            }

            if(responseObj.finalize.hasOwnProperty("submitted")) {
                context.submitted = responseObj.finalize.submitted;
            }

            if(responseObj.finalize.hasOwnProperty("txHash")) {
                context.txHash = responseObj.finalize.txHash;
            }

            if(responseObj.finalize.hasOwnProperty("betId") && responseObj.finalize.hasOwnProperty("betHash") && responseObj.finalize.hasOwnProperty("hashData")) {

                let betHash = responseObj.finalize.betHash;
                let hashData = JSON.parse(responseObj.finalize.hashData);
                let betId = responseObj.finalize.betId;
                context.betId = betId;

                dispatch(refreshBetList([betId]));

                dispatch({
                    type: 'MONITOR_BET_IDS',
                    payload: [betId]
                });

                dispatch({
                    type: 'UPDATE_HASH_DATA',
                    payload: { [betId]: {hashData, betHash} }
                });
            }
            else {
                if(context.txHash !== "") {
                    dispatch({
                        type: 'MONITOR_TX_HASHES',
                        payload: [{txHash: context.txHash, data: { keyUsername, keyProposal, keyVersion, betHash, txHash, network }}]
                    });
                }
                else {
                    dispatch({
                        type: 'MONITOR_TX_HASHES',
                        payload: []
                    });
                }
            }
        }

        context.pendingFinalize = false;
        dispatch(changePageContext(context, "VIEW_PROPOSAL"));
      }
      else {
        dispatch(changePageContext({pendingFinalize:false}, "VIEW_PROPOSAL"));
      }

      return null;
    }).catch((error) => {
      dispatch(changePageContext({pendingFinalize:false}, "VIEW_PROPOSAL"));
      return null;
    });
  }
}


export function updateEthPrice() {
  return function(dispatch) {

    let ethPrice = store.getState().bet.ethPrice;

    let updateNeeded = true;
    if(ethPrice && ethPrice.hasOwnProperty("timestamp") && ethPrice.timestamp !== null) {

      if(moment().tz('America/Los_Angeles').diff(ethPrice.timestamp, 'minutes') < 1) {
        updateNeeded = false;
      }
    }

    console.log("updateEthPrice: " + updateNeeded);

    if(updateNeeded) {
      const options = {
        uri: "https://ethbet.network/getEthPrice"
      };
      
      return requestPromise(options).then((response) => {
      
        let responseObj = JSON.parse(response);
        if(responseObj && responseObj.hasOwnProperty('success') && responseObj.success === true && responseObj.hasOwnProperty('USD')) {

          responseObj.timestamp = moment().tz('America/Los_Angeles');

          dispatch({
            type: 'UPDATE_ETH_PRICE',
            payload: responseObj
          });
        }
    
        return null;
      }).catch(() => {

        return null;
      });
    }

    return null;
  }
}

export function signMessage(username, ethAccount, tweetId) {
  return function(dispatch) {

    // web3Instance, 
    let blockNum = "5709922";//web3Instance.eth.blockNumber;
    var blockHash = "0xaea36003ef897f01db5c45b47f6ea1fdc0e8a52fff6c2baa18079f6a9ecccd65"; //web3Instance.eth.getBlock(blockNum).hash;

    console.log("blockNum");
    console.log(blockNum);
    console.log(blockHash);

    signMessagePromise(ethAccount, username, tweetId, blockNum, blockHash).then((signature) => {
      const { result="" } = signature;

      return verifyAddress(ethAccount, username, tweetId, blockNum, blockHash, result);
    }).then((response) => {

      console.log(response);

      let uuid = (response && response.hasOwnProperty("uuid") ? response.uuid : "");

      if(uuid !== "") {
        setCookie("uuid", uuid, 365);
        setCookie("uuid_" + ethAccount.toLowerCase(), uuid, 365);
        setCookie("authAddress", ethAccount, 365);
        setCookie("authUsername", username, 365);
      }

      dispatch({
        type: 'CHANGE_PAGE_CONTEXT',
        payload: { context: {addressVerified: response && response.verified, uuid: (response && response.hasOwnProperty("uuid") ? response.uuid : "") }, page: "LINK_ACCOUNT" }
      });

      let authentication = store.getState().bet.authentication;

      dispatch(loginFromEthAccount(authentication.ethAccount, authentication.network, false));

    });
  }
}

export function signMessagePromise(ethAccount, username, tweetId, blockNum, blockHash) {

    const { web3Instance } = store.getState().bet.web3;

    const message = getSignatureMessage(ethAccount, username, tweetId, blockNum, blockHash);
    //"My twitter username is @" + username.toLowerCase() + " and my Ethereum address is " + ethAccount.toLowerCase() + ".\n\n\n\n--------------------------\nTwitter verification URL: https://twitter.com/" + username.toLowerCase() + "/status/" + tweetId + "\nLatest Ethereum block #: " + blockNum + "\nLatest Ethereum block hash: " + blockHash;

    console.log(message);

    return new Promise((resolve, reject) => {

      web3Instance.currentProvider.sendAsync({
        method: 'personal_sign',
        params: [
          utils.fromAscii(message),
          ethAccount,
        ],
        from: ethAccount,
      }, function (err, signature) {
        resolve(signature);
      });
    }).then((response) => {
      console.log("SIGNED!!!");
      console.log(response);
      return response;
    });
    
}

export function deposit(betId, amount) {
    return function(dispatch) {
  
      let amountWei = utils.toWei(amount.toString(), 'ether');
      const { betManagerInstance, ethAccount } = store.getState().bet.web3;
  
      betManagerInstance.deposit.sendTransaction(betId, {from: ethAccount, value:amountWei}).then((result) => {
  
          console.log("Deposit successful");
  
      }).catch(() => {
      });
  
    }
  }

export function withdraw(betId) {
  return function(dispatch) {
    const { betManagerInstance, ethAccount } = store.getState().bet.web3;

    betManagerInstance.withdraw.sendTransaction(betId, {from: ethAccount}).then((result) => {

        console.log("Withdraw successful");

    }).catch(() => {
    });
  }
}

export function requestDefaultJudgment(betId) {
    return function(dispatch) {
      const { betManagerInstance, ethAccount } = store.getState().bet.web3;
  
      betManagerInstance.requestDefaultJudgment.sendTransaction(betId, {from: ethAccount}).then((result) => {
  
          console.log("RequestDefaultJudgment successful");
  
      }).catch(() => {
      });
    }
  }

/*
export function sendERC20Tokens(betId, tokenContract, receiver, value) {
  return function(dispatch) {
    const { betManagerInstance, ethAccount } = store.getState().bet.web3;

    betManagerInstance.sendERC20Tokens.sendTransaction(betId, tokenContract, receiver, value, {from: ethAccount}).then((result) => {

        console.log("SendERC20Tokens successful");

    }).catch(() => {
    });
  }
}
*/

export function requestArbitration(betId, amount) {
  return function(dispatch) {
    let amountWei = utils.toWei(amount.toString(), 'ether');
    const { betManagerInstance, ethAccount } = store.getState().bet.web3;

    betManagerInstance.requestArbitration.sendTransaction(betId, {from: ethAccount, value:amountWei}).then((result) => {

        console.log("RequestArbitration successful");

    }).catch(() => {
    });
  }
}

export function resolve(betId, resolutionNum) {
  return function(dispatch) {
    const { betManagerInstance, ethAccount } = store.getState().bet.web3;

    betManagerInstance.resolve.sendTransaction(betId, stringToInteger(resolutionNum), {from: ethAccount}).then((result) => {

        console.log("Resolve successful");

    }).catch(() => {
    });
  }
}

export function navigate(page, authentication) {
  return function(dispatch) {

      if(page !== store.getState().bet.selectedPage) {

        let context = {};
        let input = {};
        let clear = true;
  
        if(page === "LINK_ACCOUNT") {
  
          let username = "";
          if(authentication && authentication.username && authentication.username !== "") {
            username = authentication.username;
          }
  
          input = {"username": username};
          context = {"step": "CONNECT_TWITTER"};
        }

        if(page !== "VIEW_PROPOSAL") {
            dispatch({
                type: 'MONITOR_BET_IDS',
                payload: []
            });

            dispatch({
                type: 'MONITOR_TX_HASHES',
                payload: []
            });
        }
  
        dispatch({
          type: 'NAVIGATE',
          payload: { page, context, input, clear }
        });
      }
      else {

        // Don't navigate, just update
        if(page === "SUMMARY") {
          dispatch(getBetSummary(authentication.username));

          dispatch({
            type: 'NAVIGATE',
            payload: { page, context: {}, input: {}, clear: false }
          });
  
        }
      }

  }
}

export function loadProposalData(navContext, authentication) {
    return function(dispatch) {

        let context = {};
        let input = {};

        if(navContext 
        && navContext.hasOwnProperty("common") 
        && navContext.hasOwnProperty("versionList") 
        && navContext.common.hasOwnProperty("participant1")
        && navContext.common.hasOwnProperty("participant2")
        && navContext.common.hasOwnProperty("arbiter")) {

            let keyProposal = navContext.key.proposal;
            let keyUsername = navContext.key.username;

            context.finalize = {};
            context.final = false;
            context.submitted = false;
            if(navContext.hasOwnProperty("finalize")) {
                context.finalize = navContext.finalize;

                if(navContext.finalize.hasOwnProperty("final")) {
                    context.final = navContext.finalize.final;
                }

                if(navContext.finalize.hasOwnProperty("submitted")) {
                    context.submitted = navContext.finalize.submitted;
                }

                if(navContext.finalize.hasOwnProperty("txHash")) {
                    context.txHash = navContext.finalize.txHash;
                }
                
                if(context.final && navContext.finalize.hasOwnProperty("betId") && navContext.finalize.hasOwnProperty("betHash") && navContext.finalize.hasOwnProperty("hashData")) {
                    let betHash = navContext.finalize.betHash;
                    let hashData = JSON.parse(navContext.finalize.hashData);
                    let betId = navContext.finalize.betId;
                    context.betId = betId;

                    dispatch(refreshBetList([betId]));

                    dispatch({
                        type: 'MONITOR_BET_IDS',
                        payload: [betId]
                    });

                    dispatch({
                        type: 'UPDATE_HASH_DATA',
                        payload: { [betId]: {hashData, betHash} }
                    });
                }
                else {
                    let betHash = navContext.finalize.hasOwnProperty("betHash") ? navContext.finalize.betHash : "";
                    let txHash = navContext.finalize.hasOwnProperty("txHash") ? navContext.finalize.txHash : "";
                    let network = navContext.finalize.hasOwnProperty("network") ? navContext.finalize.network : "";
                    let keyVersion = navContext.finalize.hasOwnProperty("keyVersion") ? navContext.finalize.keyVersion : "";

                    if(txHash !== "") {
                        dispatch({
                            type: 'MONITOR_TX_HASHES',
                            payload: [{txHash: txHash, data: { keyUsername, keyProposal, keyVersion, betHash, txHash, network }}]
                        });
                    }
                    else {
                        dispatch({
                            type: 'MONITOR_TX_HASHES',
                            payload: []
                        });
                    }
                }
            }

            let keyVersion = "";
            let versionList = navContext.versionList;
            if(versionList.length > 0) {
                let versionData = navContext.version;
                keyVersion = versionData.keyVersion;

                if(versionData.hasOwnProperty("status")) {

                    let arbiter = navContext.common.arbiter;

                    context.participant1 = navContext.common.participant1;
                    context.participant2 = navContext.common.participant2;
                    context.arbiter = arbiter;
                    context.versionList = versionList;
                    context.keyVersion = keyVersion;
                    context.versionData = versionData;
                    context.versionStatus = versionData.status;
                    context.keyProposal = keyProposal;
                    context.keyUsername = keyUsername;
                    context.requestedArbiter = navContext.requestedArbiter || {};
                    context.rejectedArbiter = navContext.rejectedArbiter || {};

                    context.yourStatus = "";
                    if(authentication.username !== "") {
                        let username = authentication.username;
                        if(versionData.status.hasOwnProperty(username)) {
                            context.yourStatus = versionData.status[username];
                        }
                    }

                    context.comments = [];
                    if(navContext.hasOwnProperty("comments")) {
                        context.comments = navContext.comments;
                    }

                    input = getInputFromVersionData(versionData, arbiter);

                    context.pendingLoadProposalData = false;
                    context.step = "VIEW";

                    if(navContext.hasOwnProperty("twoWayVerified")) {
                        context.twoWayVerified = navContext.twoWayVerified;
                    }

                    let proposalDataMap = {};
                    let combinedKey = JSON.stringify([keyUsername, keyProposal]);
                    proposalDataMap[combinedKey] = navContext;
                    dispatch({
                        type: 'UPDATE_PROPOSAL_DATA',
                        payload: proposalDataMap
                    });

                    dispatch(restoreTextInput(input, "VIEW_PROPOSAL"));
                    dispatch(changePageContext(context, "VIEW_PROPOSAL"));
                }
            }
        }
    }
}

export function getInputFromVersionData(versionData, arbiter) {
  let input = {};
  input.amount1 = versionData.amount1;
  input.amount2 = versionData.amount2;
  input.betText = versionData.text;
  input.arbiter = arbiter;
  input.arbitrationFee = versionData.arbitrationFee;
  input.daysBeforeDefaultJudgement = versionData.daysBeforeDefaultJudgement;
  input.betExpiresDate = versionData.betExpiresDate;
  input.arbitrationRequestDate = versionData.arbitrationRequestDate;
  return input;
}

export function changeSelectedVersion(authentication, keyVersion) {
  return function(dispatch) {
    let { VIEW_PROPOSAL_CONTEXT={} } = store.getState().bet.pageContext;
    let curContext = VIEW_PROPOSAL_CONTEXT; //Don't submit this directly
    
    let context = {};
    let versionList = curContext.versionList;
    let arbiter = curContext.arbiter;
    if(versionList.length > 0) {
      let versionData = versionList[0];
      for(let i=0; i<versionList.length; i++) {
        if(versionList[i].keyVersion === keyVersion) {
          versionData = versionList[i]
        }
      }

      if(versionData.keyVersion === keyVersion) {
        context.keyVersion = keyVersion;
        context.versionData = versionData;
        context.versionStatus = versionData.status;
        context.yourStatus = "";
        if(authentication.username !== "") {
          let username = authentication.username;
          if(versionData.status.hasOwnProperty(username)) {
            context.yourStatus = versionData.status[username];
          }
        }
        
        let input = getInputFromVersionData(versionData, arbiter);

        dispatch(restoreTextInput(input, "VIEW_PROPOSAL"));
        dispatch(changePageContext(context, "VIEW_PROPOSAL"));
      }
      
      return null;
    }
  }
}

export function submitTwitterForAddress(accountId, tweetId) {
  return function(dispatch) {

      const { twitterAccountInstance, ethAccount } = store.getState().bet.web3;

      twitterAccountInstance.register.sendTransaction(ethAccount, accountId, tweetId, {from: ethAccount}).then((result) => {

        dispatch({
          type: 'SUBMIT_TWITTER_FOR_ADDRESS',
          payload: result
        });
      });

  }
}

export function showOverlay(val) {
  return function(dispatch) {
    dispatch({
      type: 'SHOW_OVERLAY',
      payload: val
    });
  }
}

export function showAuthStatus(val) {
    return function(dispatch) {
      dispatch({
        type: 'SHOW_AUTH_STATUS',
        payload: val
      });
    }
  }

export function changeTextInput(name, value, page) {
  return function(dispatch) {

      let input = {};
      input[name] = value;

      dispatch({
        type: 'CHANGE_TEXT_INPUT',
        payload: { input, page }
      });
  }
}

export function restoreTextInput(input, page) {
  return function(dispatch) {
    dispatch({
      type: 'CHANGE_TEXT_INPUT',
      payload: { input, page }
    });
  }
}

export function changePageContext(context, page) {
  return function(dispatch) {
      dispatch({
        type: 'CHANGE_PAGE_CONTEXT',
        payload: { context, page }
      });
  }
}

export function updateScreenDimensions(width, height) {
  return function(dispatch) {

      dispatch({
        type: 'UPDATE_SCREEN_DIMENSIONS',
        payload: { width, height }
      });
      
  }
}

export function showProfileMenu(status) {
  return function(dispatch) {

      dispatch({
        type: 'SHOW_PROFILE_MENU',
        payload: status
      });   
  }
}

export function setVersionStatus(uuid, status, keyUsername, keyProposal, keyVersion) {
  return function(dispatch) {

    dispatch(changePageContext({pendingStatusUpdate:true}, "VIEW_PROPOSAL"));

    const options = {
      uri: "https://ethbet.network/setVersionStatus?uuid=" + uuid + "&username=" + keyUsername + "&key=" + keyProposal + "&version=" + keyVersion + "&status=" + status
    };
    let t0 = performance.now();
    
    return requestPromise(options).then((response) => {

      let t1 = performance.now();
      console.log("Time for setVersionStatus " + (t1 - t0) + " milliseconds.");
    
      let responseObj = JSON.parse(response);
      console.log(responseObj);
      if(responseObj && responseObj.hasOwnProperty('success') && responseObj.hasOwnProperty('versionList') && responseObj.hasOwnProperty('yourStatus') && responseObj.hasOwnProperty('versionStatus') && responseObj.success === true) {
        let context = {};

        let versionList = responseObj.versionList;

        for(let i=0; i<versionList.length; i++) {
          if(versionList[i].keyVersion === keyVersion) {
            context.versionData = versionList[i];
            break;
          }
        }

        //Not implemented yet on server
        if(responseObj.hasOwnProperty("twoWayVerified")) {
          context.twoWayVerified = responseObj.twoWayVerified;
        }

        context.versionList = versionList;
        context.yourStatus = responseObj.yourStatus;
        context.versionStatus = responseObj.versionStatus;
        context.pendingStatusUpdate = false;
        dispatch(changePageContext(context, "VIEW_PROPOSAL"));
      }
      else {
        dispatch(changePageContext({pendingStatusUpdate:false}, "VIEW_PROPOSAL"));
      }

      return null;
    }).catch(() => {
      dispatch(changePageContext({pendingStatusUpdate:false}, "VIEW_PROPOSAL"));
    });
  }
}


export function createBetProposal(uuid, participant2, betText, amount1, amount2, arbiter, arbitrationFee, betExpiresDate, arbitrationRequestDate, daysBeforeDefaultJudgement) {
  return function(dispatch) {

    dispatch(changePageContext({createBetStarted: true }, "PROPOSE_BET"));

    var options = {
        method: 'POST',
        uri: 'https://ethbet.network/createBetProposal',
        body: { uuid, participant2, betText, amount1, amount2, arbiter, arbitrationFee, betExpiresDate, arbitrationRequestDate, daysBeforeDefaultJudgement },
        json: true
    };

    return requestPromise(options).then((response) => {

      if(response && response.hasOwnProperty("success") && response.hasOwnProperty("proposal") && response.hasOwnProperty("version") && response.hasOwnProperty("participant1") && response.success === true) {

        const keyProposal = response.proposal;
        const keyVersion = response.version;
        const keyParticiant1 = response.participant1;

        dispatch(changePageContext({step: "SUCCESS", keyProposal, keyVersion, keyParticiant1 }, "PROPOSE_BET"));
      }
      else {
        dispatch(changePageContext({createBetStarted: false, createBetFailed: true }, "PROPOSE_BET"));
      }

      return null;
    }).catch(() => {
      dispatch(changePageContext({createBetStarted: false, createBetFailed: true }, "PROPOSE_BET"));
    });
  }
}


export function versionBetProposal(uuid, username, keyUsername, keyProposal, betText, amount1, amount2, arbitrationFee, betExpiresDate, arbitrationRequestDate, daysBeforeDefaultJudgement) {
  return function(dispatch) {
    dispatch(changePageContext({createVersionStarted: true, createVersionFailed: false }, "VIEW_PROPOSAL"));

    var options = {
        method: 'POST',
        uri: 'https://ethbet.network/versionBetProposal',
        body: { uuid, keyUsername, keyProposal, betText, amount1, amount2, arbitrationFee, betExpiresDate, arbitrationRequestDate, daysBeforeDefaultJudgement },
        json: true
    };

    return requestPromise(options).then((response) => {

      if(response && response.hasOwnProperty("success") && response.success === true) {

        window.store = store;

        let { VIEW_PROPOSAL_CONTEXT={} } = store.getState().bet.pageContext;
        let context = JSON.parse(JSON.stringify(VIEW_PROPOSAL_CONTEXT)); // Needed to ensure proper React update

        let keyVersion = response.version;
        let newVersion = { text: betText, amount1, amount2, arbitrationFee, betExpiresDate, arbitrationRequestDate, daysBeforeDefaultJudgement };

        let status = {};
        status[response.participant1] = "ACCEPTED";
        status[response.participant2] = "NO_RESPONSE";
        status[response.arbiter] = "NO_RESPONSE";
        newVersion.status = status;
        newVersion.proposedBy = username;
        newVersion.keyVersion = keyVersion;
        newVersion.keyProposal = keyProposal;
        newVersion.keyUsername = keyUsername;
        newVersion.createDate = response.createDate;

        context.participant1 = response.participant1;
        context.participant2 = response.participant2;
        context.arbiter = response.arbiter;
        context.versionList.push(newVersion);
        context.keyVersion = keyVersion;
        context.versionData = newVersion;
        context.versionStatus = status;
        context.keyProposal = keyProposal;
        context.keyUsername = keyUsername;
        context.cacheInput = null;

        context.yourStatus = "ACCEPTED";
        context.createVersionStarted = false;
        context.createVersionFailed = false;
        context.step = "VIEW";

        //Not implemented yet on server
        if(response.hasOwnProperty("twoWayVerified")) {
          context.twoWayVerified = response.twoWayVerified;
        }

        console.log(response);
        console.log(context);

        dispatch(changePageContext(context, "VIEW_PROPOSAL"));
      }
      else {
        dispatch(changePageContext({createVersionStarted: false, createVersionFailed: true }, "VIEW_PROPOSAL"));
      }

      return null;
    }).catch(() => {
      dispatch(changePageContext({createVersionStarted: false, createVersionFailed: true }, "VIEW_PROPOSAL"));
    });
  }
}

export function getProposalDetails(keyUsername, keyProposal) {
    const options = {
      uri: "https://ethbet.network/getProposalDetails?username=" + keyUsername + "&key=" + keyProposal
    };
    let t0 = performance.now();
    
    return requestPromise(options).then((response) => {

      let t1 = performance.now();
      console.log("Time for  getProposalDetails " + (t1 - t0) + " milliseconds.");
    
      let responseObj = JSON.parse(response);
      console.log(responseObj);
      if(responseObj && responseObj.hasOwnProperty('success') && responseObj.success === true) {
        return responseObj;
      }

      return {success: false};
    });
}

export function addComment(uuid, keyUsername, keyProposal, comment) {
  return function(dispatch) {

    dispatch(changePageContext({pendingComment:true}, "VIEW_PROPOSAL"));

    const options = {
      uri: "https://ethbet.network/addComment?uuid=" + uuid + "&username=" + keyUsername + "&key=" + keyProposal + "&comment=" + comment
    };
    let t0 = performance.now();
    
    return requestPromise(options).then((response) => {

      let t1 = performance.now();
      console.log("Time for addComment " + (t1 - t0) + " milliseconds.");
    
      let responseObj = JSON.parse(response);
      console.log(responseObj);
      if(responseObj && responseObj.hasOwnProperty('success') && responseObj.hasOwnProperty('comments') && responseObj.hasOwnProperty('keyComment') && responseObj.success === true) {
        let context = {};
        context.comments = responseObj.comments;
        context.pendingComment = false;
        dispatch(changePageContext(context, "VIEW_PROPOSAL"));
        dispatch(changeTextInput("newComment", "", "VIEW_PROPOSAL"));
      }
      else {
        dispatch(changePageContext({pendingComment:false}, "VIEW_PROPOSAL"));
      }

      return null;
    }).catch(() => {
      dispatch(changePageContext({pendingComment:false}, "VIEW_PROPOSAL"));
    });
  }
}

export function requestNewArbiter(uuid, keyUsername, keyProposal, arbiter) {
  return function(dispatch) {

    dispatch(changePageContext({pendingRequestNewArbiter:true}, "VIEW_PROPOSAL"));

    const options = {
      uri: "https://ethbet.network/requestNewArbiter?uuid=" + uuid + "&username=" + keyUsername + "&key=" + keyProposal + "&arbiter=" + arbiter
    };
    let t0 = performance.now();
    
    return requestPromise(options).then((response) => {

      let t1 = performance.now();
      console.log("Time for requestNewArbiter " + (t1 - t0) + " milliseconds.");
    
      let responseObj = JSON.parse(response);
      console.log(responseObj);
      if(responseObj && responseObj.hasOwnProperty('success') && responseObj.hasOwnProperty('requestedArbiter') && responseObj.hasOwnProperty('key') && responseObj.success === true) {
        let context = {};
        context.requestedArbiter = responseObj.requestedArbiter;
        //context.rejectedArbiter = responseObj.rejectedArbiter || {};
        context.pendingRequestNewArbiter = false;
        context.changeArbiterOverlay = false;
        dispatch(showOverlay(false));
        dispatch(changePageContext(context, "VIEW_PROPOSAL"));
        dispatch(changeTextInput("proposedArbiter", "", "VIEW_PROPOSAL"));
      }
      else {
        dispatch(changePageContext({pendingRequestNewArbiter:false}, "VIEW_PROPOSAL"));
      }

      return null;
    }).catch(() => {
      dispatch(changePageContext({pendingRequestNewArbiter:false}, "VIEW_PROPOSAL"));
    });
  }
}

export function acceptNewArbiter(uuid, keyUsername, keyProposal, arbiter) {
  return function(dispatch) {

    dispatch(changePageContext({pendingAcceptNewArbiter:true}, "VIEW_PROPOSAL"));

    const options = {
      uri: "https://ethbet.network/acceptNewArbiter?uuid=" + uuid + "&username=" + keyUsername + "&key=" + keyProposal + "&arbiter=" + arbiter
    };
    let t0 = performance.now();
    
    return requestPromise(options).then((response) => {

      let t1 = performance.now();
      console.log("Time for acceptNewArbiter " + (t1 - t0) + " milliseconds.");
    
      let responseObj = JSON.parse(response);
      console.log(responseObj);
      if(responseObj && responseObj.hasOwnProperty('success') && responseObj.hasOwnProperty('newArbiter') && responseObj.hasOwnProperty('oldArbiter') && responseObj.hasOwnProperty('key') && responseObj.success === true) {
        let context = {};
        context.requestedArbiter = {};
        context.rejectedArbiter = {};
        context.arbiter = responseObj.newArbiter;
        context.oldArbiter = responseObj.oldArbiter;
        context.pendingAcceptNewArbiter = false;
        dispatch(changePageContext(context, "VIEW_PROPOSAL"));
        dispatch(changeTextInput("arbiter", arbiter, "VIEW_PROPOSAL"));
      }
      else {
        dispatch(changePageContext({pendingAcceptNewArbiter:false}, "VIEW_PROPOSAL"));
      }

      return null;
    }).catch(() => {
      dispatch(changePageContext({pendingAcceptNewArbiter:false}, "VIEW_PROPOSAL"));
    });
  }
}

export function rejectNewArbiter(uuid, keyUsername, keyProposal, arbiter) {
  return function(dispatch) {

    dispatch(changePageContext({pendingRejectNewArbiter:true}, "VIEW_PROPOSAL"));

    const options = {
      uri: "https://ethbet.network/rejectNewArbiter?uuid=" + uuid + "&username=" + keyUsername + "&key=" + keyProposal + "&arbiter=" + arbiter
    };
    let t0 = performance.now();
    
    return requestPromise(options).then((response) => {

      let t1 = performance.now();
      console.log("Time for rejectNewArbiter " + (t1 - t0) + " milliseconds.");
    
      let responseObj = JSON.parse(response);
      console.log(responseObj);
      if(responseObj && responseObj.hasOwnProperty('success') && responseObj.hasOwnProperty('rejectedArbiter') && responseObj.hasOwnProperty('key') && responseObj.success === true) {
        let context = {};
        context.requestedArbiter = {};
        context.rejectedArbiter = responseObj.rejectedArbiter;
        context.pendingRejectNewArbiter = false;
        dispatch(changePageContext(context, "VIEW_PROPOSAL"));
      }
      else {
        dispatch(changePageContext({pendingRejectNewArbiter:false}, "VIEW_PROPOSAL"));
      }

      return null;
    }).catch(() => {
      dispatch(changePageContext({pendingRejectNewArbiter:false}, "VIEW_PROPOSAL"));
    });
  }
}


export function getBetSummary(username) {
    return function(dispatch) {

        let { SUMMARY_CONTEXT={} } = store.getState().bet.pageContext;
        let { pendingBetSummary=false } = SUMMARY_CONTEXT;

        if(!pendingBetSummary) {
            dispatch(changePageContext({pendingBetSummary:true}, "SUMMARY"));

            const options = {
                uri: "https://ethbet.network/getProposalsForUser?username=" + username
            };
            let t0 = performance.now();
        
            return requestPromise(options).then((response) => {
        
                let t1 = performance.now();
                console.log("Time for getProposalsForUser " + (t1 - t0) + " milliseconds.");
            
                let responseObj = JSON.parse(response);
                console.log(responseObj);
                if(responseObj && responseObj.hasOwnProperty('success') && responseObj.hasOwnProperty('data') && responseObj.success === true) {
                    let context = {};
                    context.initialized = true;
                    context.data = responseObj.data;
                    context.pendingBetSummary = false;

                    let betIdList = [];
                    let hashDataMap = {};
                    let proposalDataMap = {};
                    if(context && context.data && context.data.length > 0) {
                        for(let i=0; i<context.data.length; i++) {
                            let entry = context.data[i];
                            if(entry.hasOwnProperty("finalize") && entry.finalize !== null && entry.finalize.hasOwnProperty("betId") && entry.finalize.hasOwnProperty("betHash") && entry.finalize.hasOwnProperty("hashData")) {
                                let betHash = entry.finalize.betHash;
                                let hashData = JSON.parse(entry.finalize.hashData);
                                let betId = entry.finalize.betId;
                                betIdList.push(betId);
                                hashDataMap[betId] = {hashData, betHash};
                            }

                            let combinedKey = JSON.stringify([entry.key.username, entry.key.proposal]);
                            proposalDataMap[combinedKey] = entry;
                        }
                    }

                    dispatch({
                        type: 'MONITOR_BET_IDS',
                        payload: betIdList
                    });

                    dispatch({
                        type: 'UPDATE_HASH_DATA',
                        payload: hashDataMap
                    });

                    dispatch({
                        type: 'UPDATE_PROPOSAL_DATA',
                        payload: proposalDataMap
                    });

                    dispatch(changePageContext(context, "SUMMARY"));
                    dispatch(changeTextInput("newComment", "", "SUMMARY"));
                }
                else {
                    dispatch(changePageContext({pendingBetSummary:false}, "VIEW_PROPOSAL"));
                }
        
                return null;
            }).catch(() => {
                dispatch(changePageContext({pendingBetSummary:false}, "VIEW_PROPOSAL"));
            });
        }
    }
}


export function viewProposalLoadAndNav(keyUsername, keyProposal) {
  return function(dispatch) {

    dispatch(changePageContext({pendingNav:true}, "SUMMARY"));
    dispatch(navigate("VIEW_PROPOSAL", store.getState().bet.authentication)); 

    getProposalDetails(keyUsername, keyProposal).then((response) => {

      dispatch(changePageContext({pendingNav:false}, "SUMMARY"));

      if(response && response.hasOwnProperty("success") && response.success === true) {
        dispatch(loadProposalData(response, store.getState().bet.authentication));
      }

    }).catch(() => {
      dispatch(changePageContext({pendingNav:false}, "SUMMARY"));
    });

  }
}

export function dataForUUID(uuid) {
  const options = {
    uri: "https://ethbet.network/dataForUUID?uuid=" + uuid
  };
  let t0 = performance.now();
  
  return requestPromise(options).then((response) => {

    let t1 = performance.now();
    console.log("Time for  dataForUUID " + (t1 - t0) + " milliseconds.");
  
    let responseObj = JSON.parse(response);
    //console.log("dataForUUID");
    //console.log(responseObj);
    if(responseObj && responseObj.hasOwnProperty('success') && responseObj.hasOwnProperty('address') && responseObj.hasOwnProperty('data') && responseObj.data.hasOwnProperty('username') && responseObj.data.hasOwnProperty('tweetId') && responseObj.success === true) {
      return {hasDatabaseAuth: true, username: responseObj.data.username, tweetId: responseObj.data.tweetId, address: responseObj.address};
    }

    return {hasDatabaseAuth: false};
  });
}

export function dataForAddress(address) {
  const options = {
    uri: "https://ethbet.network/dataForAddress?address=" + address
  };
  let t0 = performance.now();
  
  return requestPromise(options).then((response) => {

    let t1 = performance.now();
    console.log("Time for  dataForAddress " + (t1 - t0) + " milliseconds.");
  
    let responseObj = JSON.parse(response);
    //console.log("dataForAddress");
    //console.log(responseObj);
    if(responseObj && responseObj.hasOwnProperty('success') && responseObj.hasOwnProperty('address') && responseObj.hasOwnProperty('data') && responseObj.data.hasOwnProperty('username') && responseObj.data.hasOwnProperty('tweetId') && responseObj.success === true) {
      return {twoWayExists: true, username: responseObj.data.username, tweetId: responseObj.data.tweetId, address: responseObj.address};
    }

    return {twoWayExists: false};
  });
}

export function linkAccountPageVerification(type, details) {
  return function(dispatch) {

    if(!window.hasOwnProperty("linkAccountStart")) {
      window.linkAccountStart = 1;
    }

    if(!window.hasOwnProperty("linkAccountEnd")) {
      window.linkAccountEnd = 1;
    }

    let newLinkAccountNum = window.linkAccountStart + 1;

    if(window.linkAccountStart === window.linkAccountEnd) {

      if(type === "username") {

        let { username, address } = details;

        window.linkAccountStart = newLinkAccountNum;

        verifyUsername(username, address).then((response) => {
          window.linkAccountEnd = newLinkAccountNum;
          dispatch({
            type: 'CHANGE_PAGE_CONTEXT',
            payload: { context: {twitterVerified: response && response.verified, tweetId: (response.hasOwnProperty("tweetId") ? response.tweetId : "")}, page: "LINK_ACCOUNT" }
          });
        }).catch(() => {
          window.linkAccountEnd = newLinkAccountNum;
          dispatch({
            type: 'CHANGE_PAGE_CONTEXT',
            payload: { context: {twitterVerified: false, tweetId: ""}, page: "LINK_ACCOUNT" }
          });
        });
      }
    }

    return null;
  }
}

export function verifyUsername(username, address) {
  const options = {
    uri: "https://ethbet.network/verifyUsername?username=" + username + "&address=" + address
  };
  let t0 = performance.now();

  console.log(options);
  
  return requestPromise(options).then((response) => {

    let t1 = performance.now();
    console.log("Time for verifyUsername " + (t1 - t0) + " milliseconds.");
  
    let responseObj = JSON.parse(response);
    if(responseObj && responseObj.hasOwnProperty('verified') && responseObj.hasOwnProperty('address') && responseObj.hasOwnProperty('username') && responseObj.hasOwnProperty('tweetId') && responseObj.verified === true) {
      return {verified: true, username: responseObj.username, address: responseObj.address, tweetId: responseObj.tweetId};
    }

    return {verified: false};
  });
}

export function verifyAddress(address, username, tweet, num, hash, signature) {
  const options = {
    uri: "https://ethbet.network/verifyAddress?address=" + address
       + "&username=" + username
       + "&tweet=" + tweet
       + "&num=" + num
       + "&hash=" + hash
       + "&signature=" + signature
  };
  let t0 = performance.now();

  console.log(options);
  
  return requestPromise(options).then((response) => {

    let t1 = performance.now();
    console.log("Time for verifyAddress " + (t1 - t0) + " milliseconds.");
  
    let responseObj = JSON.parse(response);
    console.log(responseObj);
    
    if(responseObj && responseObj.hasOwnProperty('verified') && responseObj.hasOwnProperty('address') && responseObj.hasOwnProperty('username') && responseObj.hasOwnProperty('uuid') && responseObj.verified === true) {
      return {verified: true, username: responseObj.username, address: responseObj.address, uuid: responseObj.uuid};
    }

    return {verified: false};
  });
}

export function updateLoginStatus(status) {
  return function(dispatch) {

    const {ethAccount="", network=""} = store.getState().bet.authentication;

    if(status) {
        setCookie("allowLoggedIn", "1", 365);
        dispatch(loginFromEthAccount(ethAccount, network, true));
    }
    else {
      eraseCookie("uuid");
      eraseCookie("authAddress");
      eraseCookie("authUsername");
      eraseCookie("noauthAddress");
      eraseCookie("noauthUsername");
      eraseUUIDCookies();
      setCookie("allowLoggedIn", "0", 3650);

      dispatch(loginFromEthAccount(ethAccount, network, false));
    }
  }
}

export function getAllowLoggedIn() {
  let allowLoggedInCookie = getCookie("allowLoggedIn");

  let allowLoggedIn = false;
  if(allowLoggedInCookie === "1") {
    allowLoggedIn = true;
  }
  return allowLoggedIn;
}

export function showAuthFlow() {

  const { showAuthFlow=false } = store.getState().bet.authentication;

  return showAuthFlow;
}

export function checkLoginAndDispatchAuthentication(authentication) {
  return function(dispatch) {

    let allowLoggedIn = getAllowLoggedIn();

    if(!allowLoggedIn) {
      authentication.loggedIn = false;
      authentication.hasDatabaseAuth = false;
      authentication.uuid = "";
      //authentication.ethAccount = "";
      //authentication.username = "";
      //authentication.twoWayExists = false;
      authentication.tweetId = "";

      eraseCookie("uuid");
      eraseCookie("authAddress");
      eraseCookie("authUsername");
      //eraseCookie("noauthAddress");
      //eraseCookie("noauthUsername");
      eraseUUIDCookies();
    }

    const cookieNameUUIDForMetamask = "uuid_" + authentication.ethAccount.toLowerCase();
    authentication.cookie_uuid = getCookie("uuid");
    authentication.cookie_authAddress = getCookie("authAddress");
    authentication.cookie_authUsername = getCookie("authUsername");
    authentication.cookie_noauthAddress = getCookie("noauthAddress");
    authentication.cookie_noauthUsername = getCookie("noauthUsername");
    authentication.cookie_uuidForMetamask = getCookie(cookieNameUUIDForMetamask);
    authentication.cookie_allowLoggedIn = getCookie("allowLoggedIn");

    dispatch({
      type: 'UPDATE_AUTHENTICATION',
      payload: authentication
    });
  }
}

export function loginFromEthAccount(addr, network, loginBtnAction) {
  return function(dispatch) {

    console.log("loginFromEthAccount");

    const prevAuthentication = store.getState().bet.authentication;

    let currentAuthNum = 1;
    if(window.hasOwnProperty("authNum")) {
      currentAuthNum = window.authNum + 1;
    }
    window.authNum = currentAuthNum;

    const selectedAddress = addr ? addr.toLowerCase() : "";

    console.log("Show link account: " + loginBtnAction);

    //setCookie("uuid", "480f5952-729b-472f-8afd-94a9613ee6ab", 365);
    //setCookie("uuid_0x627306090abaB3A6e1400e9345bC60c78a8BEf57".toLowerCase(), "480f5952-729b-472f-8afd-94a9613ee6ab", 365);

    let allowLoggedIn = getAllowLoggedIn();

    if(selectedAddress && selectedAddress !== "") {

      let uuidCookie = getCookie("uuid");
      let authAddressCookie = getCookie("authAddress");
      let authUsernameCookie = getCookie("authUsername");

      let uuidFromAddressCookie = getCookie("uuid_" + selectedAddress.toLowerCase());
      if(uuidFromAddressCookie && uuidFromAddressCookie !== "") {

        let noAuthUsername = "";
        let noAuthUUID = "";
        let noAuthAlreadyLoggedIn = false;

        if(uuidCookie === uuidFromAddressCookie && authAddressCookie === selectedAddress && uuidCookie && uuidCookie !== "" && authAddressCookie && authAddressCookie !== "" && authUsernameCookie && authUsernameCookie !== "") {
          //Read again in case of race condition
          allowLoggedIn = getAllowLoggedIn();

          noAuthUsername = authUsernameCookie;
          noAuthUUID = uuidCookie;
          noAuthAlreadyLoggedIn = allowLoggedIn;
  
          let authentication = {
            ethAccount: selectedAddress,
            network: network,
            loggedIn: allowLoggedIn,
            hasMetamask: true,
            hasDatabaseAuth: false,
            uuid: uuidCookie,
            recordedEthAddress: authAddressCookie,
            username: authUsernameCookie,
            num: currentAuthNum,
            trace: "A",
            showAuthFlow: allowLoggedIn && showAuthFlow(),
            twoWayExists: false,
            tweetId: ""
          };
  
          dispatch(checkLoginAndDispatchAuthentication(authentication));
        }
  
        dataForUUID(uuidFromAddressCookie).then((response) => {

          if (window.authNum !== currentAuthNum) { return null; }

          console.log(response);

          //Read again in case of race condition
          allowLoggedIn = getAllowLoggedIn();

          let authentication = prevAuthentication;
  
          if(response.hasDatabaseAuth) {

            setCookie("uuid", uuidFromAddressCookie, 365);
            setCookie("uuid_" + selectedAddress.toLowerCase(), uuidFromAddressCookie, 365);
            setCookie("authAddress", selectedAddress, 365);
            setCookie("authUsername", response.username, 365);
            eraseCookie("noauthAddress");
            eraseCookie("noauthUsername");
                  
            authentication = {
              ethAccount: selectedAddress,
              network: network,
              loggedIn: allowLoggedIn,
              hasMetamask: true,
              hasDatabaseAuth: true,
              uuid: uuidFromAddressCookie,
              recordedEthAddress: selectedAddress,
              username: response.username,
              num: currentAuthNum,
              trace: "B",
              showAuthFlow: allowLoggedIn && showAuthFlow(),
              twoWayExists: true,
              tweetId: response.tweetId
            };
          }
          else {
            authentication = {
              ethAccount: selectedAddress,
              network: network,
              loggedIn: noAuthAlreadyLoggedIn && allowLoggedIn,
              hasMetamask: true,
              hasDatabaseAuth: false,
              uuid: noAuthUUID,
              recordedEthAddress: selectedAddress,
              username: noAuthUsername,
              num: currentAuthNum,
              trace: "C",
              showAuthFlow: allowLoggedIn && (loginBtnAction || showAuthFlow()),
              twoWayExists: false,
              tweetId: ""
            };
          }

          dispatch(checkLoginAndDispatchAuthentication(authentication));

        }).catch(() => {

          if (window.authNum !== currentAuthNum) { return null; }
          console.log("CATCH ----");

          //Read again in case of race condition
          allowLoggedIn = getAllowLoggedIn();

          let authentication = store.getState().bet.authentication;
          authentication.loggedIn = allowLoggedIn;
          authentication.showAuthFlow = allowLoggedIn && showAuthFlow();
          authentication.trace = "D";

          /*
          let authentication = {
            ethAccount: selectedAddress,
            network: network,
            loggedIn: allowLoggedIn,
            hasMetamask: true,
            hasDatabaseAuth: false,
            uuid: "",
            recordedEthAddress: selectedAddress,
            username: "",
            num: currentAuthNum,
            trace: "D",
            showAuthFlow: allowLoggedIn && showAuthFlow(),
            twoWayExists: false,
            tweetId: ""
          };
          */
    
          dispatch(checkLoginAndDispatchAuthentication(authentication));
               
        });
      }
      else {

        let noauthAddressCookie = getCookie("noauthAddress");
        let noauthUsernameCookie = getCookie("noauthUsername");

        if(noauthAddressCookie && noauthUsernameCookie && noauthAddressCookie === selectedAddress && noauthUsernameCookie !== "") {
          //Read again in case of race condition

          console.log("selectedAddress: " + selectedAddress + "," + noauthAddressCookie);

          allowLoggedIn = getAllowLoggedIn();

          let authentication = {
              ethAccount: selectedAddress,
              network: network,
              loggedIn: allowLoggedIn,
              hasMetamask: true,
              hasDatabaseAuth: false,
              uuid: "",
              recordedEthAddress: noauthAddressCookie,
              username: noauthUsernameCookie,
              num: currentAuthNum,
              trace: "E",
              showAuthFlow: allowLoggedIn && showAuthFlow(),
              twoWayExists: true,
              tweetId: ""
          };

          dispatch(checkLoginAndDispatchAuthentication(authentication));
        }
        else {
          //Read again in case of race condition
          allowLoggedIn = getAllowLoggedIn();

          let authentication = {
              ethAccount: selectedAddress,
              network: network,
              loggedIn: false,
              hasMetamask: true,
              hasDatabaseAuth: false,
              uuid: "",
              recordedEthAddress: selectedAddress,
              username: "",
              num: currentAuthNum,
              trace: "F",
              showAuthFlow: allowLoggedIn && showAuthFlow(),
              twoWayExists: false,
              tweetId: ""
          };

          dispatch(checkLoginAndDispatchAuthentication(authentication));

        }
  
        dataForAddress(selectedAddress).then((response) => {

          if (window.authNum !== currentAuthNum) { return null; }
          console.log(response);
          
          if(response.twoWayExists) {
            //Read again in case of race condition
            allowLoggedIn = getAllowLoggedIn();

            if(allowLoggedIn && response.address === selectedAddress) {
              setCookie("noauthAddress", response.address, 365);
              setCookie("noauthUsername", response.username, 365);
            }

            let authentication = {
                ethAccount: selectedAddress,
                network: network,
                loggedIn: allowLoggedIn,
                hasMetamask: true,
                hasDatabaseAuth: false,
                uuid: "",
                recordedEthAddress: response.address,
                username: response.username,
                num: currentAuthNum,
                trace: "G",
                showAuthFlow: allowLoggedIn && showAuthFlow(),
                twoWayExists: true,
                tweetId: response.tweetId
            };

            dispatch(checkLoginAndDispatchAuthentication(authentication));

          }
          else {
            let authentication = {
              ethAccount: selectedAddress,
              network: network,
              loggedIn: false,
              hasMetamask: true,
              hasDatabaseAuth: false,
              uuid: "",
              recordedEthAddress: selectedAddress,
              username: "",
              num: currentAuthNum,
              trace: "H",
              showAuthFlow: allowLoggedIn && (loginBtnAction || showAuthFlow()),
              twoWayExists: false,
              tweetId: ""
            };
      
            dispatch(checkLoginAndDispatchAuthentication(authentication));
          }

        }).catch(() => {

          if (window.authNum !== currentAuthNum) { return null; }
          console.log("CATCH 2 ----");

          //Read again in case of race condition
          allowLoggedIn = getAllowLoggedIn();

          let authentication = store.getState().bet.authentication;
          authentication.loggedIn = allowLoggedIn;
          authentication.showAuthFlow = allowLoggedIn && showAuthFlow();
          authentication.trace = "I";

          /*
          let authentication = {
            ethAccount: selectedAddress,
            network: network,
            loggedIn: false,
            hasMetamask: true,
            hasDatabaseAuth: false,
            uuid: "",
            recordedEthAddress: selectedAddress,
            username: "",
            num: currentAuthNum,
            trace: "I",
            showAuthFlow: allowLoggedIn && (loginBtnAction || showAuthFlow()),
            twoWayExists: false,
            tweetId: ""
          };
          */
    
          dispatch(checkLoginAndDispatchAuthentication(authentication));
        });
      }
    }
    else {

      //No selected address

      let uuidCookie = getCookie("uuid");
      let authAddressCookie = getCookie("authAddress");
      let authUsernameCookie = getCookie("authUsername");
      let noauthAddressCookie = getCookie("noauthAddress");
      let noauthUsernameCookie = getCookie("noauthUsername");
      
      if(uuidCookie && uuidCookie !== "" && authAddressCookie && authAddressCookie !== "" && authUsernameCookie && authUsernameCookie !== "") {

        //Read again in case of race condition
        allowLoggedIn = getAllowLoggedIn();

        let authentication = {
          ethAccount: selectedAddress,
          network: network,
          loggedIn: allowLoggedIn,
          hasMetamask: false,
          hasDatabaseAuth: false,
          uuid: uuidCookie,
          recordedEthAddress: authAddressCookie,
          username: authUsernameCookie,
          num: currentAuthNum,
          trace: "J",
          showAuthFlow: allowLoggedIn && showAuthFlow(),
          twoWayExists: false,
          tweetId: ""
        };

        dispatch(checkLoginAndDispatchAuthentication(authentication));
      

        dataForUUID(uuidCookie).then((response) => {

          if (window.authNum !== currentAuthNum) { return null; }

          console.log(response);

          //Read again in case of race condition
          allowLoggedIn = getAllowLoggedIn();

          let authentication = {
            ethAccount: selectedAddress,
            network: network,
            loggedIn: allowLoggedIn,
            hasMetamask: false,
            hasDatabaseAuth: false,
            uuid: uuidCookie,
            recordedEthAddress: authAddressCookie,
            username: authUsernameCookie,
            num: currentAuthNum,
            trace: "K",
            showAuthFlow: allowLoggedIn && showAuthFlow(),
            twoWayExists: false,
            tweetId: ""
          };

          if(response.hasDatabaseAuth) {

            setCookie("uuid", uuidCookie, 365);
            setCookie("uuid_" + selectedAddress.toLowerCase(), uuidCookie, 365);
            setCookie("authAddress", response.address, 365);
            setCookie("authUsername", response.username, 365);
            eraseCookie("noauthAddress");
            eraseCookie("noauthUsername");
                  
            authentication = {
                ethAccount: selectedAddress,
                network: network,
                loggedIn: allowLoggedIn,
                hasMetamask: false,
                hasDatabaseAuth: true,
                uuid: uuidCookie,
                recordedEthAddress: response.address,
                username: response.username,
                num: currentAuthNum,
                trace: "L",
                showAuthFlow: allowLoggedIn && showAuthFlow(),
                twoWayExists: true,
                tweetId: response.tweetId
            };
          }

          dispatch(checkLoginAndDispatchAuthentication(authentication));

        }).catch(() => {
          //Authentication updated earlier.  Do nothing
          if (window.authNum !== currentAuthNum) { return null; }
        });
      }
      else if(noauthAddressCookie && noauthUsernameCookie && noauthAddressCookie !== "" && noauthUsernameCookie !== "" && selectedAddress === "") {
        //Read again in case of race condition

        console.log("noauthAddressCookie: " + noauthAddressCookie);

        allowLoggedIn = getAllowLoggedIn();

        let authentication = {
            ethAccount: selectedAddress,
            network: network,
            loggedIn: allowLoggedIn,
            hasMetamask: false,
            hasDatabaseAuth: false,
            uuid: "",
            recordedEthAddress: noauthAddressCookie,
            username: noauthUsernameCookie,
            num: currentAuthNum,
            trace: "M",
            showAuthFlow: allowLoggedIn && showAuthFlow(),
            twoWayExists: true,
            tweetId: ""
        };

        dispatch(checkLoginAndDispatchAuthentication(authentication));
      }
      else {

        //Read again in case of race condition
        allowLoggedIn = getAllowLoggedIn();
        
        let authentication = {
          ethAccount: selectedAddress,
          network: network,
          loggedIn: false,
          hasMetamask: false,
          hasDatabaseAuth: false,
          uuid: "",
          recordedEthAddress: "",
          username: "",
          num: currentAuthNum,
          trace: "N",
          showAuthFlow: allowLoggedIn && (loginBtnAction || showAuthFlow()),
          twoWayExists: false,
          tweetId: ""
        };
  
        dispatch(checkLoginAndDispatchAuthentication(authentication));
      }
    }
  }
}

export function setCookie(name, value, days) {
  let expires = "";

  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

export function getCookie(name) {
  let nameEQ = name + "=";
  let ca = document.cookie.split(';');

  for (let i=0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') { 
      c = c.substring(1,c.length); 
    }

    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
  }

  return null;
}

export function eraseUUIDCookies() {
  let cookies = document.cookie.split(";");

  for (let i=0; i<cookies.length; i++) {

    let cookieName = cookies[i].split("=")[0];
    if(/^uuid_.*$/.test(cookieName)) {
      eraseCookie(cookieName);
    }
  }
}

export function eraseCookie(name) {   
  document.cookie = name + '=; Max-Age=-99999999; path=/';
}




// WEBPACK FOOTER //
// ./src/actions/betActions.js